// extracted by mini-css-extract-plugin
export default {"countWithStatus__badge":"styles_count-with-status__badge__++WE-"};